
<div class="delegates-page">
  <div class="section-card">
    <div class="table-toolbar">
      <div class="toolbar-heading">
        <div class="toolbar-icon">
          <i class="pi pi-users"></i>
        </div>

        <div class="toolbar-text">
          <h3>Gestione delegati</h3>
          <p>
            Consulta e gestisci i delegati, i ruoli e
            i responsabili gerarchici.
          </p>
        </div>
      </div>

      <p-button
        label="Aggiungi delegato"
        icon="pi pi-plus"
        styleClass="toolbar-button"
        (onClick)="createNewDelegate()"
      ></p-button>
    </div>

    <p-table
      [value]="delegates"
      dataKey="delegateId"
      editMode="row"
      [scrollable]="true"
      responsiveLayout="scroll"
      styleClass="delegates-table p-datatable-sm"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="actions-column">Azioni</th>
          <th>Nome e cognome</th>
          <th>Ruolo</th>
          <th>Descrizione</th>
          <th>Responsabile gerarchico</th>
        </tr>
      </ng-template>

      <ng-template
        pTemplate="body"
        let-delegate
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="delegate">
          <td>
            <div class="row-actions">
              <button
                *ngIf="!editing"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text edit-button"
                pTooltip="Modifica delegato"
                (click)="onRowEditInit(delegate)"
              ></button>

              <button
                *ngIf="!editing"
                pButton
                pRipple
                type="button"
                icon="pi pi-trash"
                class="p-button-rounded p-button-text delete-button"
                pTooltip="Elimina delegato"
                (click)="removeDelegate(delegate)"
              ></button>

              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                class="p-button-rounded p-button-text p-button-success"
                pTooltip="Salva modifiche"
                (click)="onRowEditSave(delegate)"
              ></button>

              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-danger"
                pTooltip="Annulla modifiche"
                (click)="onRowEditCancel(delegate, ri)"
              ></button>
            </div>
          </td>

          <td>
            <div class="delegate-person">
              <span class="person-avatar">
                <i class="pi pi-user"></i>
              </span>

              <span class="person-name">
                {{ delegate.user.name }}
                {{ delegate.user.lastName }}
              </span>
            </div>
          </td>

          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-button
                  [outlined]="true"
                  styleClass="editor-button"
                  (onClick)="roleOverlay.toggle($event)"
                >
                  {{ delegate.label || 'Seleziona ruolo' }}
                </p-button>

                <p-overlayPanel #roleOverlay>
                  <p-listbox
                    [options]="roles"
                    [(ngModel)]="delegate.label"
                    [multiple]="false"
                  >
                    <ng-template let-role pTemplate="item">
                      {{ role }}
                    </ng-template>
                  </p-listbox>
                </p-overlayPanel>
              </ng-template>

              <ng-template pTemplate="output">
                <span class="role-badge">
                  {{ delegate.label }}
                </span>
              </ng-template>
            </p-cellEditor>
          </td>

          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-button
                  [outlined]="true"
                  styleClass="editor-button"
                  (onClick)="descriptionOverlay.toggle($event)"
                >
                  Modifica descrizione
                </p-button>

                <p-overlayPanel #descriptionOverlay>
                  <textarea
                    rows="6"
                    cols="35"
                    pInputTextarea
                    [(ngModel)]="delegate.roleDescription"
                  ></textarea>
                </p-overlayPanel>
              </ng-template>

              <ng-template pTemplate="output">
                <span
                  class="description-text"
                  [pTooltip]="delegate.roleDescription || ''"
                  tooltipPosition="top"
                >
                  {{
                    delegate.roleDescription
                      ? (delegate.roleDescription | slice:0:65)
                      : 'Nessuna descrizione'
                  }}
                  <ng-container
                    *ngIf="delegate.roleDescription?.length > 65"
                  >...</ng-container>
                </span>
              </ng-template>
            </p-cellEditor>
          </td>

          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-button
                  [outlined]="true"
                  styleClass="editor-button"
                  (onClick)="fatherOverlay.toggle($event)"
                >
                  {{ getFatherName(delegate.upperDelegateId) }}
                </p-button>

                <p-overlayPanel #fatherOverlay>
                  <p-listbox
                    [options]="possibleFathers(delegate.delegateId!)"
                    [multiple]="false"
                    (onChange)="changedFather(delegate, $event)"
                  >
                    <ng-template let-father pTemplate="item">
                      {{
                        father === -1
                          ? 'Claudio Cecchi'
                          : getFatherName(father)
                      }}
                    </ng-template>
                  </p-listbox>
                </p-overlayPanel>
              </ng-template>

              <ng-template pTemplate="output">
                <span class="hierarchy-name">
                  <i class="pi pi-sitemap"></i>
                  {{ getFatherName(delegate.upperDelegateId) }}
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">
            <div class="empty-state">
              <i class="pi pi-users"></i>
              <strong>Nessun delegato presente</strong>
              <span>
                Non ci sono delegati da visualizzare.
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- DIALOG NUOVO DELEGATO -->
<p-dialog
  header="Nuovo delegato"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  [modal]="true"
  [visible]="creating !== undefined"
  (visibleChange)="onCreateDialogVisibleChange($event)"
  [style]="{
    width: 'calc(100vw - 32px)',
    maxWidth: '560px',
    maxHeight: 'calc(100vh - 32px)'
  }"
  styleClass="delegates-modal"
>
  <div
    *ngIf="creating !== undefined"
    class="delegate-modal-form"
  >
    <div class="modal-description">
      <i class="pi pi-info-circle"></i>
      <span>Inserisci i dati del nuovo delegato.</span>
    </div>

    <div class="form-field">
      <label for="delegate-user">Iscritto</label>

      <p-autoComplete
        id="delegate-user"
        field="lastName"
        [(ngModel)]="creating.user"
        [dropdown]="true"
        [suggestions]="filteredSubscribers"
        (completeMethod)="filterSubscriber($event)"
        [multiple]="false"
        [forceSelection]="true"
        appendTo="body"
        scrollHeight="240px"
        panelStyleClass="delegate-subscriber-panel"
        styleClass="full-width-autocomplete"
        inputStyleClass="delegate-input"
        placeholder="Cerca e seleziona un iscritto"
      >
        <ng-template let-user pTemplate="item">
          {{ user.name }} {{ user.lastName }}
        </ng-template>

        <ng-template let-user pTemplate="selectedItem">
          {{ user.name }} {{ user.lastName }}
        </ng-template>
      </p-autoComplete>
    </div>

    <div class="form-field">
      <label>Ruolo</label>

      <p-button
        [outlined]="true"
        styleClass="modal-select-button"
        (onClick)="newRoleOverlay.toggle($event)"
      >
        {{
          creating.label === ''
            ? 'Seleziona ruolo'
            : creating.label
        }}
        <i class="pi pi-chevron-down"></i>
      </p-button>

      <p-overlayPanel #newRoleOverlay>
        <p-listbox
          [options]="roles"
          [(ngModel)]="creating.label"
          [multiple]="false"
        >
          <ng-template let-role pTemplate="item">
            {{ role }}
          </ng-template>
        </p-listbox>
      </p-overlayPanel>
    </div>

    <div class="form-field">
      <label>Responsabile gerarchico</label>

      <p-button
        [outlined]="true"
        styleClass="modal-select-button"
        (onClick)="newFatherOverlay.toggle($event)"
      >
        {{ getFatherName(creating.upperDelegateId) }}
        <i class="pi pi-chevron-down"></i>
      </p-button>

      <p-overlayPanel #newFatherOverlay>
        <p-listbox
          [options]="possibleFathers(creating.delegateId || -2)"
          [multiple]="false"
          (onChange)="changedFather(creating, $event)"
        >
          <ng-template let-father pTemplate="item">
            {{
              father === -1
                ? 'Claudio Cecchi'
                : getFatherName(father)
            }}
          </ng-template>
        </p-listbox>
      </p-overlayPanel>
    </div>

    <div class="form-field">
      <label for="delegate-description">Descrizione</label>

      <textarea
        id="delegate-description"
        rows="5"
        pInputTextarea
        [(ngModel)]="creating.roleDescription"
        placeholder="Descrivi il ruolo e le responsabilità"
      ></textarea>
    </div>

    <div class="modal-actions">
      <p-button
        label="Conferma"
        icon="pi pi-check"
        [disabled]="!creating.user"
        (onClick)="confirmCreate()"
      ></p-button>
    </div>
  </div>
</p-dialog>
